module.exports = __webpack_public_path__ + "static/img/59.fe35219f.png";